import React from 'react';
import { useTranslation } from 'react-i18next';
import { SellerConnectScreeningMode } from 'models/SellerConnectEngine';
import Tag from 'components/ListingPortfolioCard/components/Tag';
import { INTAKE_VIA_COLORS, INTAKE_VIA_LABELS } from '../../data';
import classNames from 'classnames';

import './IntakeViaChip.styles.scss';

type IntakeViaChipProps = {
  className?: string;
  mode: SellerConnectScreeningMode;
};

const IntakeViaChip: React.FC<IntakeViaChipProps> = (props) => {
  const { className, mode } = props;

  const { t } = useTranslation();

  return (
    <Tag
      className={classNames('intake-via-chip', className)}
      variant={INTAKE_VIA_COLORS[mode]}
      content={t(INTAKE_VIA_LABELS[mode])}
    />
  );
};

export default IntakeViaChip;
